
    import '/mnt/src/components/Radio/index.md?watch=parent';
    export const demoIndex = {
  ids: ["radio-demo-basicdemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Radio/index.md?type=demo')
};